<template>
  <div class="revisite needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="revisite.title" text="revisite.info" ></Info>
    <div class="title-revisite">
      <h3>{{$t('revisite.title')}}</h3>
    </div>
    <div v-if="display">
      <div v-for="(progressBar, index) in progressBars">
        <ProgressBar :color="progressBar.color" :width="progressBar.width" :text="progressBar.text" :key="index"></ProgressBar>
      </div>
    </div>
    <div v-else>
      </br>
      {{$t('revisite.textWhenNoEndDate')}}
    </div>
  </div>
</template>

<script>
  import ProgressBar from './ProgressBar.vue'
  import Info from './Info.vue'
  export default {
    name: 'revisite',
    components: {
      ProgressBar,
      Info
    },
    props: {
      index: Number, 
      result: Object
    },
    data() {
      return {
        fullscreen: false,
        info: {
         text: {keyLabel: 'civilities.man'}
        }
      }
    },
    computed: {
      display: function(){
        return this.result.aggregations.hasOwnProperty('nb_customers_m3_all')
      },
      progressBars: function(){
        let nbCustomersM3All = '0'
        let nbCustomersM6All = '0'
        let nbCustomersM12All = '0'
        let nbCustomersM24All = '0'
        let hits = this.result.hits ? this.result.hits.total : 0
        if (this.result && this.result.aggregations['nb_customers_m3_all'] && hits > 0) {

          nbCustomersM3All = (this.result.aggregations['nb_customers_m3_all'].doc_count * 100 / hits).toFixed(1)
          nbCustomersM6All = (this.result.aggregations['nb_customers_m6_all'].doc_count * 100 / hits).toFixed(1)
          nbCustomersM12All = (this.result.aggregations['nb_customers_m12_all'].doc_count * 100 / hits).toFixed(1)
          nbCustomersM24All = (this.result.aggregations['nb_customers_m24_all'].doc_count * 100 / hits).toFixed(1)
        }
        
        return [
          {
            color: "#A3A1FB",
            width: `${nbCustomersM3All}%`,
            text: this.$t('revisite.nbCustomersM3AllLegend')
          },
          {
            color: "#5EE2A0",
            width: `${nbCustomersM6All}%`,
            text: this.$t('revisite.nbCustomersM6AllLegend')
          },
          {
            color: "#FF6565",
            width: `${nbCustomersM12All}%`,
            text: this.$t('revisite.nbCustomersM12AllLegend')
          },
          {
            color: "#FEC163",
            width: `${nbCustomersM24All}%`,
            text: this.$t('revisite.nbCustomersM24AllLegend')
          }
        ]
      }
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/revisite.sass"
</style>
